const microModal = require('micromodal');
microModal.init({});

export default function infoModal(header: string, content: string)
{
    let modal = document.getElementById('modal-info');
    if (modal === null) {
        return;
    }

    modal.querySelector('.js-modal-info-header').innerHTML = header;
    modal.querySelector('.js-modal-info-content').innerHTML = content;

    document.querySelectorAll('.modal.is-open').forEach(item => microModal.close(item.id));
    microModal.show('modal-info', {awaitCloseAnimation: true});
}
